<template>
  <div>
    <router-view></router-view>
    <footer class="footer">
      <div class="footer-item">
        <router-link to="/bangtian" class="link">
          <img class="icon" src="@/assets/yuyue.png" alt="Logo" />
          <span class="di">访客预约</span>
        </router-link>
      </div>
      <div class="footer-item">
        <router-link to="/shenpi" class="link">
          <img class="icon" src="@/assets/shenpi.png" alt="Logo" />
          <span class="di">到访审批</span>
        </router-link>
      </div>
      <!-- 根据 isErjiShenpi 的值动态显示或隐藏二级审批按钮 -->
      <div v-if="isErjiShenpi" class="footer-item">
        <router-link to="/shenpi2" class="link">
          <img class="icon" src="@/assets/shenpi.png" alt="Logo" />
          <span class="di">二级审批</span>
        </router-link>
      </div>
      <div class="footer-item">
        <router-link to="/yuyue" class="link">
          <img class="icon" src="@/assets/jilu.png" alt="Logo" />
          <span class="di">预约记录</span>
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isErjiShenpi: false, // 用于控制二级审批按钮的显示
    };
  },
  mounted() {
    this.checkErjiShenpi();
  },
  methods: {
    async checkErjiShenpi() {
      try {
        const response = await this.$axios.get('/api/check_erji', {
        });
        console.log(response.data.data)

        // 假设后端返回的格式是 { id: 'some_id' } 或 { id: null }
        if (response.data.data) {
          this.isErjiShenpi = true;
        } else {
          this.isErjiShenpi = false;
        }
      } catch (error) {
        console.error('检查二级审批人状态失败', error);
        this.isErjiShenpi = false; // 如果请求失败，隐藏二级审批按钮
      }
    },
  },
};
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px; /* 底部导航栏的高度 */
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); /* 阴影效果 */
  z-index: 1000; /* 确保在内容之上 */
}

.footer-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.di {
  font-size: 13px;
  font-weight: bold;
}

.link {
  text-decoration: none; /* 移除链接下的横线 */
  color: #666; /* 默认文字颜色 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link.router-link-exact-active,
.link:hover {
  color: #007bff; /* 激活状态或悬停时的文字颜色 */
}

.icon {
  width: 18px; /* Logo大小 */
  height: 18px;
  margin-bottom: 2px; /* Logo与文字之间的间距 */
}

.iconfont {
  font-size: 24px;
  margin-bottom: 5px;
}

p {
  margin: 0;
}
</style>